import React from 'react';
import {MasterLayout} from 'components/layouts';
import {OrderHistoryDetailContainer} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';

class OrderHistoryDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.OrderHistoryDetail;
  }

  render() {
    return (
      <MasterLayout>
        <OrderHistoryDetailContainer params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default MemberZone(OrderHistoryDetail);



// WEBPACK FOOTER //
// ./pages/users/OrderHistoryDetail.jsx